/* Kioka Studio — tema Shopify · interacciones */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = document.documentElement;

  /* ---------- relojes ---------- */
  function tick() {
    var L = root.lang || 'es';
    $$('[data-tz]').forEach(function (t) {
      try {
        t.textContent = new Intl.DateTimeFormat(L, { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: t.dataset.tz }).format(new Date());
      } catch (e) {}
    });
  }
  tick(); setInterval(tick, 15000);

  /* ---------- entrada ---------- */
  window.addEventListener('load', function () { requestAnimationFrame(function () { root.classList.add('ready'); }); });
  setTimeout(function () { root.classList.add('ready'); }, 1500);

  /* ---------- reveal ---------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        setTimeout(function () { e.target.classList.add('done'); }, 1300);
        io.unobserve(e.target);
      }
    });
  }, { threshold: .12, rootMargin: '0px 0px -6% 0px' });
  $$('.rv').forEach(function (el) { io.observe(el); });
  var flogo = $('#flogo'); if (flogo) io.observe(flogo);

  /* ---------- manifiesto: palabras que se encienden ---------- */
  var mf = $('#mf'), mfWords = [];
  if (mf) {
    var txt = mf.textContent.trim();
    mf.setAttribute('aria-label', txt);
    mf.innerHTML = txt.split(' ').map(function (w) { return '<span class="w" aria-hidden="true">' + w + '</span>'; }).join(' ');
    mfWords = $$('.w', mf);
  }

  /* ---------- método: pasos fijos con scroll ---------- */
  var stepsEl = $('#steps'), curStep = 0, stepData = [];
  if (stepsEl) {
    stepData = $$('#m-data li').map(function (li) { return [li.dataset.h, li.dataset.p]; });
  }
  function setStep(i, force) {
    if (!stepData.length) return;
    var s = stepData[i], body = $('#m-body');
    var apply = function () {
      $('#m-num').textContent = String(i + 1).padStart(2, '0');
      $('#m-h').textContent = s[0]; $('#m-p').textContent = s[1];
      body.classList.remove('out');
    };
    if (force || reduce) apply(); else { body.classList.add('out'); setTimeout(apply, 180); }
    $$('#rail i').forEach(function (r, k) { r.classList.toggle('on', k <= i); });
    curStep = i;
  }
  if (stepData.length) setStep(0, true);

  /* ---------- barra: se oculta al bajar ---------- */
  var bar = $('#bar'), lastY = scrollY;
  function onScroll() {
    var y = scrollY, vh = innerHeight;
    if (bar) {
      bar.classList.toggle('solid', y > 40);
      bar.classList.toggle('hide', y > lastY && y > 240);
    }
    lastY = y;
    if (mfWords.length) {
      var r = mf.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      var n = Math.round(p * mfWords.length * 1.15);
      mfWords.forEach(function (w, k) { w.classList.toggle('on', k < n); });
    }
    if (stepsEl && stepData.length) {
      var st = stepsEl.getBoundingClientRect(), span = st.height - vh;
      var pr = Math.min(1, Math.max(0, -st.top / span));
      var idx = Math.min(stepData.length - 1, Math.floor(pr * stepData.length));
      if (idx !== curStep && st.top < vh && st.bottom > 0) setStep(idx);
    }
    caseParallax();
  }
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);

  /* ---------- cursor, parallax del hero, vista previa del trabajo ---------- */
  var cursor = $('#cursor'), label = $('#cursor-label');
  var tiles = $$('.tile'), peek = $('#peek'), work = $('#work');
  var mx = innerWidth / 2, my = innerHeight / 2, cx = mx, cy = my, tx = 0, ty = 0, px = 0, py = 0, qx = mx, qy = my;
  addEventListener('pointermove', function (e) { mx = e.clientX; my = e.clientY; tx = (mx / innerWidth - .5); ty = (my / innerHeight - .5); });
  var fine = matchMedia('(hover:hover) and (pointer:fine)').matches;
  function frame() {
    if (cursor) { cx += (mx - cx) * .2; cy += (my - cy) * .2; cursor.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0)'; }
    px += (tx - px) * .06; py += (ty - py) * .06;
    if (!reduce && tiles.length && scrollY < innerHeight) {
      tiles.forEach(function (t) {
        var d = +getComputedStyle(t).getPropertyValue('--d') || 0;
        t.style.setProperty('--px', (-px * d).toFixed(2) + 'px');
        t.style.setProperty('--py', (-py * d).toFixed(2) + 'px');
      });
    }
    if (peek) {
      qx += (mx - qx) * .14; qy += (my - qy) * .14;
      var pw = peek.offsetWidth, left = qx > innerWidth * 0.55 ? qx - pw - 36 : qx + 36;
      peek.style.transform = 'translate3d(' + left + 'px,' + (qy - peek.offsetHeight / 2) + 'px,0)';
    }
    requestAnimationFrame(frame);
  }
  if (fine) requestAnimationFrame(frame);

  function bigCursor(on, txt) { if (!cursor) return; cursor.classList.toggle('big', on); if (txt && label) label.textContent = txt; }
  var defaultLabel = label ? label.textContent : '';
  tiles.forEach(function (t) {
    t.addEventListener('pointerenter', function () { bigCursor(true, defaultLabel); });
    t.addEventListener('pointerleave', function () { bigCursor(false); });
  });
  $$('[data-cursor]').forEach(function (el) {
    el.addEventListener('pointerenter', function () { if (cursor) cursor.classList.add('on-blue'); bigCursor(true, el.dataset.cursor); });
    el.addEventListener('pointerleave', function () { if (cursor) cursor.classList.remove('on-blue'); bigCursor(false); });
  });
  $$('.logo .L').forEach(function (s) {
    s.addEventListener('pointerenter', function () {
      if (!reduce && s.animate) s.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-6%)' }, { transform: 'translateY(0)' }], { duration: 500, easing: 'cubic-bezier(.2,.7,.2,1)' });
    });
  });
  $$('.wrow').forEach(function (r) {
    r.addEventListener('pointerenter', function () {
      if (work) work.style.setProperty('--bg', r.dataset.c);
      if (cursor) cursor.classList.add('on-blue');
      if (peek) { peek.classList.add('on'); $$('[data-k]', peek).forEach(function (n) { n.classList.toggle('show', n.dataset.k === r.dataset.peek); }); }
    });
    r.addEventListener('pointerleave', function () {
      if (work) work.style.removeProperty('--bg');
      if (peek) peek.classList.remove('on');
      if (cursor) cursor.classList.remove('on-blue');
    });
  });

  /* ---------- botón magnético ---------- */
  $$('[data-magnet]').forEach(function (b) {
    b.addEventListener('pointermove', function (e) {
      var r = b.getBoundingClientRect();
      b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * .25) + 'px,' + ((e.clientY - r.top - r.height / 2) * .35) + 'px)';
    });
    b.addEventListener('pointerleave', function () { b.style.transform = ''; });
  });

  /* ---------- carrusel de la tienda: arrastrar ---------- */
  var tr = $('#track');
  if (tr) {
    var down = false, sx = 0, sl = 0, moved = 0;
    tr.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; down = true; moved = 0; sx = e.clientX; sl = tr.scrollLeft; });
    addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx)); if (moved > 4) tr.classList.add('drag'); tr.scrollLeft = sl - dx; });
    addEventListener('pointerup', function () { down = false; setTimeout(function () { tr.classList.remove('drag'); }, 0); });
    tr.addEventListener('click', function (e) { if (moved > 6) e.preventDefault(); }, true);
  }

  /* ---------- aviso corto ---------- */
  var toastT, toastEl = $('#toast');
  function toast(msg) { if (!toastEl) return; toastEl.textContent = msg; toastEl.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 2200); }

  /* ---------- paleta: copiar HEX ---------- */
  $$('.sw button').forEach(function (b) {
    b.addEventListener('click', function () {
      var hex = b.dataset.hex;
      try { navigator.clipboard.writeText(hex).catch(function () {}); } catch (e) {}
      toast(hex + ' ' + (toastEl ? toastEl.dataset.copied : ''));
    });
  });

  /* ---------- parallax suave de la imagen de portada del caso ---------- */
  var csFull = $('.cs-full');
  function caseParallax() {
    if (reduce || !csFull) return;
    var img = $('img', csFull), r = csFull.getBoundingClientRect();
    var p = (innerHeight - r.top) / (innerHeight + r.height);
    img.style.transform = 'translate3d(0,' + ((p - .5) * -60).toFixed(1) + 'px,0)';
  }

  /* ---------- Vass: isotipo interactivo ---------- */
  (function () {
    var wrap = $('#isowrap'); if (!wrap) return;
    var polys = $$('polygon', wrap), btns = $$('#isosw button');
    function focusPart(p) {
      if (!p) { wrap.classList.remove('f'); polys.forEach(function (x) { x.classList.remove('on'); }); return; }
      wrap.classList.add('f'); polys.forEach(function (x) { x.classList.toggle('on', x.dataset.part === p); });
    }
    btns.forEach(function (b) {
      ['pointerenter', 'focus'].forEach(function (e) { b.addEventListener(e, function () { focusPart(b.dataset.part); }); });
      ['pointerleave', 'blur'].forEach(function (e) { b.addEventListener(e, function () { focusPart(null); }); });
    });
    polys.forEach(function (p) {
      p.addEventListener('pointerenter', function () { focusPart(p.dataset.part); });
      p.addEventListener('pointerleave', function () { focusPart(null); });
      p.addEventListener('click', function () { var b = btns.filter(function (x) { return x.dataset.part === p.dataset.part; })[0]; if (b) b.click(); });
    });
  })();

  /* ---------- Welpco: pestañas Necesito ayuda / Ofrezco ayuda ---------- */
  (function () {
    var panel = $('#tabpanel'); if (!panel) return;
    var data = $$('#tab-data li').map(function (li) { return [li.dataset.h, li.dataset.p]; });
    var cur = 0, btns = $$('.tabs button');
    function setTab(i) {
      cur = i;
      var apply = function () { $('#tp-h').textContent = data[i][0]; $('#tp-p').textContent = data[i][1]; panel.classList.remove('out'); };
      if (reduce) apply(); else { panel.classList.add('out'); setTimeout(apply, 170); }
      btns.forEach(function (b) { b.setAttribute('aria-selected', String(+b.dataset.tab === i)); });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { if (+b.dataset.tab !== cur) setTab(+b.dataset.tab); }); });
  })();

  /* ---------- reserva de llamada (Google Calendar) ---------- */
  (function () {
    var bk = $('#bk'), frame = $('#bk-frame'); if (!bk) return;
    var opener = null;
    function open(from) {
      opener = from || null;
      if (!frame.getAttribute('src')) frame.src = frame.dataset.src;
      bk.hidden = false; document.body.classList.add('bk-open');
      requestAnimationFrame(function () { requestAnimationFrame(function () { bk.classList.add('on'); }); });
      setTimeout(function () { var x = $('#bk-x'); if (x) x.focus(); }, 60);
    }
    function close() {
      bk.classList.remove('on'); document.body.classList.remove('bk-open');
      setTimeout(function () { bk.hidden = true; }, reduce ? 0 : 380);
      if (opener && opener.focus) opener.focus();
    }
    $$('[data-book]').forEach(function (a) {
      a.addEventListener('click', function (e) { if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); open(a); });
    });
    $$('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && !bk.hidden) close(); });
    bk.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href],button', bk).filter(function (x) { return !x.disabled; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  })();

  /* ---------- transición azul entre el home y los casos ---------- */
  (function () {
    var wipe = $('#wipe'); if (!wipe) return;
    var KEY = 'kioka-wipe';
    try {
      if (sessionStorage.getItem(KEY)) {
        sessionStorage.removeItem(KEY);
        if (!reduce) { wipe.className = 'wipe leave'; setTimeout(function () { wipe.className = 'wipe'; }, 620); }
      }
    } catch (e) {}
    addEventListener('pageshow', function (e) { if (e.persisted) wipe.className = 'wipe'; });
    var STUDIO = /^(\/[a-z]{2}(-[A-Za-z]{2})?)?(\/(pages\/(lunoir|vass|welpco))?)?$/;
    document.addEventListener('click', function (e) {
      if (reduce || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-book')) return;
      var u; try { u = new URL(a.href, location.href); } catch (er) { return; }
      if (u.origin !== location.origin) return;
      if (u.pathname === location.pathname && u.hash) return;
      if (u.pathname === location.pathname && !u.hash && !u.search) return;
      if (!STUDIO.test(u.pathname) || !STUDIO.test(location.pathname)) return;
      e.preventDefault();
      wipe.className = 'wipe cover';
      try { sessionStorage.setItem(KEY, '1'); } catch (er) {}
      setTimeout(function () { location.href = a.href; }, 540);
    });
  })();

  /* ---------- tienda: precio de la variante y cantidades del carrito ---------- */
  (function () {
    var sel = $('[data-variants]'), price = $('[data-price]'), add = $('[data-add]');
    if (sel && price && add) {
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        price.textContent = o.dataset.price;
        var ok = o.dataset.available === 'true';
        add.disabled = !ok; add.textContent = ok ? add.dataset.addLabel : add.dataset.soldLabel;
      });
    }
    var cart = $('#cart-form');
    if (cart) $$('input[name="updates[]"]', cart).forEach(function (i) { i.addEventListener('change', function () { cart.submit(); }); });
  })();

  onScroll();
})();
